import { render, staticRenderFns } from "./DocumentsListMentor.vue?vue&type=template&id=c057a64e&scoped=true&"
import script from "./DocumentsListMentor.vue?vue&type=script&lang=js&"
export * from "./DocumentsListMentor.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsListMentor.vue?vue&type=style&index=0&id=c057a64e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c057a64e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCardActions,VIcon,VOverlay,VSheet})
